import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import {Map} from 'immutable';

import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';
import {changeCouponSlipAmount as changeCouponSlipAmountAction} from 'actions/creators/CouponRate';
import {beginSignIn as beginSignInAction, beginJoin as beginJoinAction} from 'actions/creators/Auth';

import BetType from './BetType.jsx';
import FavouriteBetAmount from './FavouriteBetAmount.jsx';

import {minAmount as MinAmountValues} from 'constants/StakeMinAmount';
import {resourceNames} from 'constants/accountResourceNames';
import { STAKES_VALUES } from '../CouponDropDownMenu.jsx';

const messages = defineMessages({
    makeBet: {
        id: 'coupon.make_bet',
        defaultMessage: 'Сделать ставку'
    },
    confirmRateValueChange: {
        id: 'coupon.confirm_rate_value_change',
        defaultMessage: 'Принять'
    },
    totalOdd: {
        id: 'coupon.total_odd_hint',
        defaultMessage: 'Общий коэффициент'
    },
    possibleWinning: {
        id: 'coupon.possible_winning_hint',
        defaultMessage: 'Возможный выигрыш'
    },
    stake: {
        id: 'coupon.stake_hint',
        defaultMessage: 'Сумма ставки'
    },
    minAmountHint: {
        id: 'coupon.min_amount_hint',
        defaultMessage: 'Мин.'
    },
    to_place_bet: {
        id: 'betpanel.unauth.to_place_bet',
        defaultMessage: 'Чтобы сделать ставку - '
    },
    should_auth: {
        id: 'betpanel.unauth.should_auth',
        defaultMessage: 'войдите'
    },
    should_register: {
        id: 'betpanel.unauth.should_register',
        defaultMessage: 'зарегистрируйтесь'
    },
    auth_or_register_to_bet: {
        id: 'betpanel.unauth.auth_or_register_to_bet',
        defaultMessage: '{signTrigger} или {joinTrigger}'
    }
});

const defaultResourceId = 4;

class UnauthControlsExt extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        user: React.PropTypes.any,
        betSlips: React.PropTypes.object,
        betSlipAmounts: React.PropTypes.object,
        currentBetTypeIndex: React.PropTypes.number.isRequired,
        betTypes: React.PropTypes.object,
        amount: React.PropTypes.number,
        odd: React.PropTypes.number,
        possibleWinAmount: React.PropTypes.number,
        makeBetAvailable: React.PropTypes.bool,
        bettingMode: React.PropTypes.object,
        nextKey: React.PropTypes.number,
        requestBetTypesAction: React.PropTypes.func.isRequired,
        changeCouponSlipAmountAction: React.PropTypes.func.isRequired,
        beginSignInAction: React.PropTypes.func.isRequired,
        beginJoinAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onFavouriteBetAmountClick = this._onFavouriteBetAmountClick.bind(this);
        this._handleLogInClick = this._handleLogInClick.bind(this);
        this._handleJoinClick = this._handleJoinClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.languageId !== this.props.languageId ||
            nextProps.betSlips !== this.props.betSlips ||
            nextProps.betSlipAmounts !== this.props.betSlipAmounts ||
            nextProps.amount !== this.props.amount ||
            nextProps.odd !== this.props.odd ||
            nextProps.possibleWinAmount !== this.props.possibleWinAmount ||
            nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex ||
            nextProps.betTypes !== this.props.betTypes ||
            nextProps.bettingMode !== this.props.bettingMode ||
            nextProps.nextKey !== this.props.nextKey;
    }

    static transformBetSlip(betSlip) {
        const rate = betSlip.get('rate');

        return new Map({
            eventId: rate.get('matchId'),
            eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
            outcomeId: rate.get('outcomeId'),
            factorId: rate.get('id'),
            factorValue: rate.get('value'),
            isConditional: false
        });
    }

    _handleLogInClick(e) {
        e.preventDefault();
        this.props.beginSignInAction();
    }

    _handleJoinClick(e) {
        e.preventDefault();
        this.props.beginJoinAction();
    }

    _onFavouriteBetAmountClick(amount) {
        const {betSlips} = this.props;
        let slipAmounts = [];

        betSlips.forEach(slip => {
            const rate = slip.get('rate');
            const rateId = rate.get('id');

            slipAmounts.push({rateId, amount, isFreeBet: false});
        });

        this.props.changeCouponSlipAmountAction(slipAmounts);
    }

    render() {
        const {bettingMode, amount, odd, possibleWinAmount, countryCode} = this.props;

        const values = STAKES_VALUES[countryCode]
        const favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
        const favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
        const favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];

        const signTrigger = (
            <FormattedMessage {...messages.should_auth}>
                {(message) => <a className="trigger" onClick={this._handleLogInClick}>{message}</a>}
            </FormattedMessage>

        );

        const joinTrigger = (
            <FormattedMessage {...messages.should_register}>
                {(message) => <a className="trigger" onClick={this._handleJoinClick}>{message}</a>}
            </FormattedMessage>
        );

        return (
            <div className="coupon-controls">
                <BetType/>
                <FormattedMessage {...messages.totalOdd}>
                    {(message) =>
                        <div className="rate" title={message}>
                            <span>{odd.toFixed(2)}</span>
                        </div>}
                </FormattedMessage>
                <FormattedMessage {...messages.possibleWinning}>
                    {(message) =>
                        <div className="balance" title={message}>
                            <span>{possibleWinAmount.toFixed(2)}</span>
                        </div>}
                </FormattedMessage>
                <FormattedMessage {...messages.stake}>
                    {(message) =>
                        <div className="bet-amount cf" title={message}>
                            <p className="total-rates"><strong style={{color:'#fff'}}>{amount.toFixed(2)}</strong></p>
                        </div>}
                </FormattedMessage>
                <div className="favourites-bet-amounts cf">
                    <FavouriteBetAmount number={1}
                                        amount={favouriteBet1Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                    <FavouriteBetAmount number={2}
                                        amount={favouriteBet2Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                    <FavouriteBetAmount number={3}
                                        amount={favouriteBet3Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                </div>
                <div className="not-auth-bet-control-message">
                    <p className="attention">
                        <FormattedMessage {...messages.to_place_bet} />
                    </p>
                    <p className="links">
                        <FormattedMessage {...messages.auth_or_register_to_bet} values={{signTrigger, joinTrigger}} />
                    </p>
                </div>
            </div>);
    }
}

function calcTotalAmount(betSlipAmounts) {
    let amount = 0;

    betSlipAmounts.forEach((value) => {
        let slipAmount = Number(value.get('amount'));

        if (!isNaN(slipAmount)) {
            amount += slipAmount;
        }
    });

    return amount;
}

function calcTotalOdd(betSlips) {
    let odd = 0;

    betSlips.forEach((slip) => {
        let rate = slip.get('rate');
        let slipOdd = Number(rate.get('value'));

        if (!isNaN(slipOdd)) {
            odd += slipOdd;
        }
    });

    return odd;
}

function calcTotalWinning(betSlips, betSlipAmounts) {
    let winning = 0;

    betSlips.forEach((slip) => {
        let rate = slip.get('rate');
        let rateId = rate.get('id');
        let slipOdd = Number(rate.get('value'));
        let slipamount = betSlipAmounts.has(rateId) ? betSlipAmounts.getIn([rateId, 'amount']) : 0;

        if (!isNaN(slipOdd) && !isNaN(slipamount)) {
            winning += (slipOdd * slipamount);
        }
    });

    return winning;
}

function isAvailableMakeBet(betSlipAmounts, minvalue) {
    let slipAmounts = betSlipAmounts.toArray();

    for (let offset = 0; offset < slipAmounts.length; offset++) {
        let slipAmount = Number(slipAmounts[offset].get('amount'));

        if (isNaN(slipAmount) || (slipAmount < minvalue)) {
            return false;
        }
    }

    return true;
}

function select(state) {
    const languageId = state.application.get('languageId');
    const user = state.auth.get('user');
    const betSlips = state.application.getIn(['coupon', 'betSlips']);
    const betSlipAmounts = state.application.getIn(['coupon', 'betSlipAmounts']);
    const betTypes = state.application.getIn(['coupon', 'betTypes']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const bettingMode = state.application.getIn(['bettingMode']);
    const betHistory = state.application.getIn(['betHistory']);

    const resourceName = (user === undefined || !user) ? resourceNames[defaultResourceId] : resourceNames[user.get('resourceId')];
    const makeBetAvailable = isAvailableMakeBet(betSlipAmounts, MinAmountValues[resourceName]);
    const amount = makeBetAvailable ? calcTotalAmount(betSlipAmounts) : 0;
    const odd = calcTotalOdd(betSlips);
    const possibleWinAmount = makeBetAvailable ? calcTotalWinning(betSlips, betSlipAmounts) : 0;

    const nextKey = betHistory.size > 0 ? (parseInt(betHistory.keySeq().maxBy(x => parseInt(x))) + 1) : 1;

    return {
        countryCode: state.application.get('countryCode'),
        languageId,
        user,
        betSlips,
        betSlipAmounts,
        betTypes,
        currentBetTypeIndex,
        amount,
        odd,
        possibleWinAmount,
        makeBetAvailable,
        bettingMode,
        nextKey
    };
}

export default connect(select, {
    requestBetTypesAction,
    changeCouponSlipAmountAction,
    beginSignInAction,
    beginJoinAction
})(UnauthControlsExt);


// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/UnauthControlsExt.jsx